import { Box } from 'common/src/designSystem/components/box';
import { getBarcodeHref } from 'common/src/util/url';
import * as React from 'react';
import { Modal } from '../../designSystem/components/modal/modal';
import { useHeavent } from '../../hooks/useHeavent';

interface IUserInformationsBarcodeModalProps {
    nameOrEmail: string;
    size: number;
    ticketId: string;
}

export const UserInformationsBarcodeModal = (props: IUserInformationsBarcodeModalProps) => {
    const { translate } = useHeavent();

    return (
        <Modal.Root>
            <Modal.Trigger>
                <Box css={{ cursor: 'pointer' }} height={props.size} width={props.size}>
                    <img
                        height="100%"
                        src={getBarcodeHref(props.ticketId, {
                            height: props.size,
                            width: props.size
                        })}
                        width="100%"
                    />
                </Box>
            </Modal.Trigger>

            <Modal.Portal>
                <Modal.Header icon="qrcode">
                    {translate('code_barres_1_82428', props.nameOrEmail)}
                </Modal.Header>

                <Modal.Content align="center" css={{ padding: '$4' }} gap="3" justify="center">
                    <Box height={100} width={100}>
                        <img
                            height="100%"
                            src={getBarcodeHref(props.ticketId, { height: 100, width: 100 })}
                            width="100%"
                        />
                    </Box>

                    <Box>{props.ticketId}</Box>
                </Modal.Content>

                <Modal.Buttons />
            </Modal.Portal>
        </Modal.Root>
    );
};
